// Production stub for the `prop-types` package. Aliased in via vite.config.mts
// (build only). Every access — `.string`, `.shape({...})`, `.arrayOf(...)`,
// `.isRequired`, calling it as a function — returns the same proxy, so no
// PropTypes API call throws. Validation is a no-op; that's fine because
// component propTypes assignments are stripped at build time and nothing in
// the codebase calls PropTypes.checkPropTypes directly.
const noop = new Proxy(function () {}, {
  get: () => noop,
  apply: () => noop,
})

export default noop
